export default __webpack_public_path__ + "static/media/CargoDetailsIcon.4515cee0.svg";